import { ref, onMounted } from 'vue'

const THEME_LIGHT = '#B8923A'
const THEME_DARK = '#0C1210'

/** Class-based dark mode with localStorage persistence. */
export function useDarkMode() {
  const getInitialPreference = () => {
    if (typeof window === 'undefined') return false
    const saved = localStorage.getItem('darkMode')
    if (saved !== null) {
      return saved === 'true'
    }
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false
  }

  const isDark = ref(getInitialPreference())

  const applyThemeColor = (value: boolean) => {
    let meta = document.head.querySelector<HTMLMetaElement>('meta[name="theme-color"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.setAttribute('name', 'theme-color')
      document.head.appendChild(meta)
    }
    meta.setAttribute('content', value ? THEME_DARK : THEME_LIGHT)
  }

  const applyPreference = (value: boolean) => {
    document.documentElement.classList.toggle('dark', value)
    localStorage.setItem('darkMode', value ? 'true' : 'false')
    applyThemeColor(value)
  }

  const toggle = () => {
    isDark.value = !isDark.value
    applyPreference(isDark.value)
  }

  onMounted(() => {
    applyPreference(isDark.value)
  })

  return {
    isDark,
    toggle,
  }
}
